import React, { useEffect, useState } from "react";

const clamp = (n) => {
  const num = Number(n);
  return Number.isFinite(num) && num > 0 ? num : 1;
};

const QuantityControl = ({ initialQuantity = 1, onChange }) => {
  const [quantity, setQuantity] = useState(clamp(initialQuantity));

  useEffect(() => {
    setQuantity(clamp(initialQuantity));
  }, [initialQuantity]);

  const incrementQuantity = () => {
    setQuantity((prev) => {
      const next = prev + 1;
      onChange?.(next);
      return next;
    });
  };

  const decrementQuantity = () => {
    setQuantity((prev) => {
      const next = prev > 1 ? prev - 1 : 1;
      onChange?.(next);
      return next;
    });
  };

  return (
    <div className="d-flex rounded-4 overflow-hidden">
      <button
        type="button"
        onClick={decrementQuantity}
        className="quantity__minus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
      >
        <i className="ph ph-minus" />
      </button>

      <input
        type="number"
        className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-4"
        value={quantity}
        min={1}
        readOnly
      />

      <button
        type="button"
        onClick={incrementQuantity}
        className="quantity__plus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
      >
        <i className="ph ph-plus" />
      </button>
    </div>
  );
};

export default QuantityControl;
